import { useState, useCallback, ReactNode } from "react";
import { TabsContext } from "./TabsContext";

interface TabsProviderProps {
  children: ReactNode;
  initialActiveIndex?: number;
}

export const TabsProvider = ({ children, initialActiveIndex = 0 }: TabsProviderProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState(initialActiveIndex);

  const setActiveTab = useCallback((index: number) => {
    setActiveTabIndex(index);
  }, []);

  return (
    <TabsContext.Provider value={{ activeTabIndex, setActiveTab }}>{children}</TabsContext.Provider>
  );
};
